// extracted by mini-css-extract-plugin
export default {"terrible":"colors_terrible__v7X3-","bad":"colors_bad__pkymP","ok":"colors_ok__DSKYb","nice":"colors_nice__RdSyZ","good":"colors_good__LgQVV","regular":"colors_regular__vn1nn"};